import styled from 'styled-components';

const Wrapper = styled.button`
  background: transparent;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 3em;
  width: 3em;
`;

function CloseButton({ className, onClick }) {
  return (
    <Wrapper className={className} onClick={onClick}>
      <svg
        width={'12'}
        height={'12'}
        viewBox={'0 0 12 12'}
        fill={'currentColor'}
        xmlns={'http://www.w3.org/2000/svg'}
      >
        <path d={'M10.2014 0.383545C10.5919 -0.00697304 11.2259 -0.00697304 11.6165 0.383545C12.0067 0.774008 12.0067 1.40715 11.6165 1.79761L7.41333 5.99976L11.6165 10.2029C12.0066 10.5934 12.0068 11.2265 11.6165 11.6169C11.2259 12.0075 10.5919 12.0075 10.2014 11.6169L5.99927 7.41382L1.7981 11.616C1.40767 12.0059 0.774452 12.0059 0.384033 11.616C-0.00639185 11.2256 -0.00618054 10.5915 0.384033 10.2009L4.58423 5.99976L0.384033 1.79858C-0.00618054 1.40804 -0.00639185 0.774934 0.384033 0.384521C0.774479 -0.00563084 1.40763 -0.0055929 1.7981 0.384521L5.99927 4.58569L10.2014 0.383545Z'} fill={'white'} />
      </svg>
    </Wrapper>
  );
}

export default CloseButton;
